import { PRODUCT_PAGE_TYPES } from "util/product/product-constants";

export const getVideoSrc = (video) => {
  if (!video) {
    return "";
  }
  if (video.vimeoId) {
    return `https://player.vimeo.com/video/${video.vimeoId}?autoplay=1`;
  }
  return `https://www.youtube.com/embed/${video.youtubeId}?wmode=transparent&rel=0&showinfo=0&fs=1&autoplay=1`;
};

export const isProductPage = (pageType?: string) => PRODUCT_PAGE_TYPES.includes(pageType as string);

export const getImageUrls = (images, spinningImage) => {
  const maxThumbnails = 5;
  if (images.length >= maxThumbnails) {
    return [...images.slice(0, maxThumbnails - 1), spinningImage, ...images.slice(maxThumbnails - 1)];
  }
  return [...images, spinningImage];
};
